// extracted by mini-css-extract-plugin
export default {"confirmation-modal__content":"cdbeaa","confirmation-modal__buttons":"fbd69c","confirmation-modal__button":"d60d4f"};